document.querySelectorAll('.js-go-to-next-brand-items').forEach(button => {
  button.addEventListener('click', () => {
    goToNext(button);
  });
});

document.querySelectorAll('.js-go-to-previous-brand-items').forEach(button => {
  button.addEventListener('click', () => {
    goToPrevious(button);
  });
});

function goToNext(button) {
  const homeBrands = button.closest('.js-home-brands');
  const carousel = homeBrands.querySelector('.js-desktop-carousel');
  const inner = carousel.querySelector('.js-carousel-inner');
  const firstItem = inner.children[0];
  const isRTL = getComputedStyle(carousel).direction === 'rtl';

  const scrollAmount = firstItem ? firstItem.offsetWidth : carousel.clientWidth;
  const maxScroll = inner.scrollWidth - carousel.clientWidth;
  const currentScroll = Math.ceil(carousel.scrollLeft);

  if (isRTL) {
    if (Math.abs(currentScroll - scrollAmount) <= maxScroll - 15) {
      carousel.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    } else {
      carousel.scrollTo({ left: maxScroll, behavior: 'smooth' });
    }
  } else {
    if (currentScroll + scrollAmount <= maxScroll - 15) {
      carousel.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    } else {
      carousel.scrollTo({ left: 0, behavior: 'smooth' });
    }
  }
}

function goToPrevious(button) {
  const homeBrands = button.closest('.js-home-brands');
  const carousel = homeBrands.querySelector('.js-desktop-carousel');
  const inner = carousel.querySelector('.js-carousel-inner');
  const firstItem = inner.children[0];
  const isRTL = getComputedStyle(carousel).direction === 'rtl';

  const scrollAmount = firstItem ? firstItem.offsetWidth : carousel.clientWidth;
  const currentScroll = Math.floor(carousel.scrollLeft);

  if (isRTL) {
    if (currentScroll + scrollAmount < inner.scrollWidth) {
      carousel.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    }
  } else {
    if (currentScroll > 15) {
      carousel.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    }
  }
}

document.querySelectorAll('.js-home-brands').forEach(homeBrands => {
  let startX = 0;
  let endX = 0;

  homeBrands.addEventListener('touchstart', (e) => {
    startX = e.touches[0].clientX;
  });

  homeBrands.addEventListener('touchend', (e) => {
    endX = e.changedTouches[0].clientX;
    const deltaX = endX - startX;

    if (Math.abs(deltaX) > 50) {
      const carousel = homeBrands.querySelector('.js-desktop-carousel');
      const isRTL = getComputedStyle(carousel).direction === 'rtl';

      if ((deltaX < 0 && !isRTL) || (deltaX > 0 && isRTL)) {
        const nextBtn = homeBrands.querySelector('.js-go-to-next-brand-items');
        if (nextBtn) goToNext(nextBtn);
      } else {
        const prevBtn = homeBrands.querySelector('.js-go-to-previous-brand-items');
        if (prevBtn) goToPrevious(prevBtn);
      }
    }
  });
});